import { put, takeLatest } from 'redux-saga/effects';

import { ShippingAddressesActionTypes } from '@/store/reducers/shipping-addreses/action-types';
import { fetchShippingAddresses } from '@/store/reducers/shipping-addreses/actions';

function* refetchShippingAddresses() {
  yield put(fetchShippingAddresses());
}

export function* ShippingAddressesSaga() {
  yield takeLatest(
    [
      ShippingAddressesActionTypes.CREATE_NEW_SHIPPING_ADDRESS.SUCCESS,
      ShippingAddressesActionTypes.UPDATE_SHIPPING_ADDRESS.SUCCESS,
      ShippingAddressesActionTypes.DELETE_SHIPPING_ADDRESS.SUCCESS,
    ],
    refetchShippingAddresses,
  );
}
